<template>
  <div class="intro">
    <p class="lead">Welcome to ETI’s first annual impact report, funded by DFID RATE, and providing a snapshot of the
      impacts of our activities working with members, partners and other key stakeholders around the world.</p>

    <p>Updated annually, ETI will quantify and demonstrate how we are improving the lives of the most vulnerable workers
      in global supply chains. The initial figures represent data and activities from calendar year 2019 and have been
      developed in line with a range of indicators aligned to ETI's Perspective 2020 Strategy. These will be developed
      and improved to ensure consistency and alignment with ETI’s 2021 and beyond strategy. In line with our commitment
      to transparency and openness, these indicators, and the methodology used to produce them, will all be publicly
      available.</p>

    <p>We currently track:</p>

    <ul>
      <li>How many workers we have reached</li>
      <li>Which countries we are active in</li>
      <li>The extent of our work with our trade union and NGO members</li>
      <li>Key findings and outputs for the period covered</li>
    </ul>

    <p>We also establish a baseline for recording the percentage by which our members have improved both their overall
      ethical trade performance and their scores in priority areas such as worker representation.</p>

    <h2>An ongoing data strategy</h2>

    <p>This is a baseline of available data in 2019, and currently provides only a snapshot of our full impact on
      workers. Since 2019, ETI has been working to develop its data management processes in order to improve our ability
      to report on our impact on workers beyond evidencing our scale and reach. This is the first stage in an important
      journey and one in which ETI is committed to continuous improvement. Future work will include, for example,
      building out robust indicators of global, country, and sector level impact.</p>

    <p> Please note that methodology explanations appear per indicator. If you have any specific questions, please
      contact ETI’s MEL Advisor, <a href="mailto:clare.fitton@eti.org.uk">Clare Fitton</a>.</p>

  </div>
</template>

<script>
export default {
  name: 'Intro'
}
</script>

<style src="./Intro.scss" lang="scss"></style>
